import React, { useEffect, useState } from "react";
import styles from "./Schedule.module.css";
import {
  NavLink,
  Outlet,
  useLocation,
} from "react-router-dom";
import { noMatchesBySport } from "../../services/apiEndpoints";
import { API_BASE_URL } from "../../services/apiHandler";



const getBackImge = (imgUrl) => {

  return `${API_BASE_URL}/${encodeURI(imgUrl)}`

}


export default function Schedule() {
  const [matchesData, setMatchesData] = useState([]);

  const fetchNoMatchesBySport = async () => {
    try {
      const NoMatchesSportRespo = await noMatchesBySport();
      console.log("Number Match of Sports", NoMatchesSportRespo.data);
      setMatchesData(NoMatchesSportRespo.data);
    } catch (error) {
      console.log("error is ", error);
    }
  };
  useEffect(() => {
    fetchNoMatchesBySport();
  }, []);

  const location = useLocation();
  const isRootRoute = location.pathname === "/schedule";
  return (
    <>
      {isRootRoute && (
        <div className={styles.mainContainer}>
          <h2>All Games</h2>
          {matchesData.map((game, index) => (
            <div key={index} className={styles.cardContainer}>
            
              <NavLink
                to={`gameSchedule/${game?.sport_row_id}`}
                state={{ sport: game?.name }}
              >
                <div
                  className={styles.backgroundImage}
                  // style={{ backgroundImage: `url(${game.img})` }}
                  style={{backgroundImage:`url(${getBackImge(game?.img)})`}}
                >
                  <div className={styles.overlay}>
                    <div className={styles.textContainer}>
                      <h2 className={styles.title}>{game?.sport_name}</h2>
                      <p>Matches: {game?.matches}</p>
                      <p>
                        Date: {game?.start_from} -- {game?.end_on}
                      </p>
                    </div>
                  </div>

                  <div className={styles.dropdownimg}>
                    <img
                      src="/images/dropdown-icon.jpg"
                      alt="dropdown icon"
                      height={"20px"}
                      width={"20px"}
                    />
                  
                  </div>
                </div>
              </NavLink>
            </div>
          ))}
        </div>
      )}
      <Outlet />
    </>
  );
}
